// src/dashboard-cliente/Cliente.js
import React, { useState, useEffect, useMemo } from 'react';
import api from '../api';
import './estilodashuser.css';

const Cliente = ({ userId }) => {
  const [cliente, setCliente] = useState(null);
  const [planos, setPlanos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [mensagem, setMensagem] = useState('');
  const [tipoMensagem, setTipoMensagem] = useState(''); // 'sucesso' | 'erro'
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    const carregarDados = async () => {
      try {
        setLoading(true);
        const [respCliente, respPlanos] = await Promise.all([
          api.get(`/api/clientes/${userId}`),
          api.get('/api/planos-ativos'),
        ]);

        setCliente(respCliente.data);
        setPlanos(respPlanos.data || []);
        setMensagem('');
        setTipoMensagem('');
      } catch (error) {
        console.error('Erro ao carregar informações do cliente:', error);
        setMensagem(
          'Erro ao carregar informações do cliente. Por favor, tente novamente mais tarde.'
        );
        setTipoMensagem('erro');
      } finally {
        setLoading(false);
      }
    };

    if (userId) {
      carregarDados();
    }
  }, [userId]);

  const handleChange = (campo, valor) => {
    setCliente((prev) => ({
      ...prev,
      [campo]: valor,
    }));
  };

  const planoSelecionado = useMemo(() => {
    if (!cliente) return null;
    return planos.find((p) => Number(p.id) === Number(cliente.plano_id)) || null;
  }, [cliente, planos]);

  const handleSalvar = async () => {
    if (!cliente) return;

    try {
      setSalvando(true);
      setMensagem('');
      setTipoMensagem('');

      await api.put(`/api/clientes/${cliente.id}`, {
        ...cliente,
      });

      setMensagem('Dados atualizados com sucesso.');
      setTipoMensagem('sucesso');
    } catch (error) {
      console.error('Erro ao atualizar dados do cliente:', error);
      setMensagem('Erro ao atualizar os dados. Tente novamente.');
      setTipoMensagem('erro');
    } finally {
      setSalvando(false);
    }
  };

  if (loading) {
    return <div className="loading">Carregando informações do cliente...</div>;
  }

  if (!cliente) {
    return (
      <div className="error-message">
        Não foi possível carregar os dados do cliente.
      </div>
    );
  }

  return (
    <div className="cliente-page">
      <div className="cliente-card cliente-card--wide">
        <div className="cliente-header">
          <div className="cliente-title">
            <span className="cliente-icon">👤</span>
            <div>
              <h3 className="cliente-h3">Meus Dados</h3>
              <div className="cliente-subtitle">
                Atualize seus contatos e confirme seu plano.
              </div>
            </div>
          </div>

          <div className="cliente-badges">
            {String(cliente.status) === "1" ? (
              <span className="badge badge-ativo">Ativo</span>
            ) : (
              <span className="badge badge-inativo">Inativo</span>
            )}

            {String(cliente.isento) === "1" ? (
              <span className="badge badge-isento">Isento</span>
            ) : (
              <span className="badge badge-normal">Normal</span>
            )}
          </div>
        </div>

        {mensagem && (
          <div
            className={
              tipoMensagem === 'erro'
                ? 'alert-box alert-error'
                : 'alert-box alert-success'
            }
          >
            {mensagem}
          </div>
        )}

        <div className="cliente-grid">
          <div className="cliente-form-group">
            <label>Nome (não editável)</label>
            <input type="text" value={cliente.nome || ''} disabled />
          </div>

          <div className="cliente-form-group">
            <label>CPF (não editável)</label>
            <input type="text" value={cliente.cpf || ''} disabled />
          </div>

          <div className="cliente-form-group">
            <label>E-mail</label>
            <input
              type="email"
              value={cliente.email || ''}
              onChange={(e) => handleChange('email', e.target.value)}
              placeholder="seuemail@exemplo.com"
            />
          </div>

          <div className="cliente-form-group">
            <label>Telefone</label>
            <input
              type="text"
              value={cliente.phone || ''}
              onChange={(e) => handleChange('phone', e.target.value)}
              placeholder="(51) 99999-9999"
            />
          </div>

          <div className="cliente-form-group cliente-form-group--full">
            <label>Plano</label>
            <select
              value={cliente.plano_id || ''}
              onChange={(e) => handleChange('plano_id', Number(e.target.value))}
            >
              <option value="">Selecione um plano</option>
              {planos.map((plano) => (
                <option key={plano.id} value={plano.id}>
                  {plano.nome} - {plano.slots_inclusos} Contas
                </option>
              ))}
            </select>

            {planoSelecionado && (
              <div className="plano-mini">
                <div className="plano-mini-title">Plano selecionado</div>
                <div className="plano-mini-line">
                  <strong>{planoSelecionado.nome}</strong>
                  <span className="plano-mini-sep">•</span>
                  Slots incluídos: {planoSelecionado.slots_inclusos}
                </div>
                <div className="plano-mini-line plano-mini-muted">
                  Base: R$ {Number(planoSelecionado.valor_base || 0).toFixed(2)} •
                  Extra por slot: R$ {Number(planoSelecionado.valor_slot_extra || 0).toFixed(2)}
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="cliente-actions">
          <button
            className="btn-salvar-dados btn-primary"
            onClick={handleSalvar}
            disabled={salvando}
          >
            {salvando ? 'Salvando...' : 'Salvar alterações'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Cliente;
